// custom-file-input.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-custom-file-input',
  templateUrl: './custom-file-input.component.html',
  styleUrls: ['./custom-file-input.component.scss'],
})
export class CustomFileInputComponent {
  @Input() accept: string | undefined;
  @Input() required: boolean = false;

  @Output() filesChanged = new EventEmitter<File[]>();

  selectedFiles: File[] = [];

  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.selectedFiles = Array.from(input.files);
      this.filesChanged.emit(this.selectedFiles);
    }
  }
}
